//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Carboplatin_Dose",
  data() {
    return {
      form: {
        female:'0',
        age: "",
        weight: "",
        cr:'',
        aug:''
      },
      hasScore: false,
      disabled: false,
      
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let crMale = 0
      let crfemale = 0
      let result = 0 
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      crMale = 1.23 * form.weight * (140 - form.age) / form.cr
      crfemale = 1.03 * form.weight * (140 - form.age) / form.cr
      if (!flag) {
        self.hasScore = false;
        return "...";
      } else {
        if(form.female == 1) {
          result = (form.aug * (crfemale + 25)).toFixed(2)
        }else {
          result = (form.aug * (crMale + 25)).toFixed(2)

        }
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Carboplatin_Dose.vue